import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";
import { useGetApplicantDetailsQuery } from "./useGetApplicantDetailsQuery";

interface UseGetSpecializationByProgramIdQueryProps {
  Id?: number;
}

const getSpecializationByProgramId = async (Id: number) => {
  return (
    await api.get(`/Concentration/ByProgram/${Id}`, {
      skipAuthRedirect: true,
    } as any)
  ).data as SpecializationByProgramResponse;
};

export const useGetSpecializationByProgramIdQuery = (
  props?: UseGetSpecializationByProgramIdQueryProps,
) => {
  const { applicantDetails } = useGetApplicantDetailsQuery();
  // const Id = props?.programId ?? applicantDetails?.programId;
  const Id = props?.Id 

  const query = useQuery({
    queryKey: ["get-specialization-by-id", Id],
    queryFn: () => getSpecializationByProgramId(Id as number),
    enabled: !!Id,
  });

  const items = (query.data?.data ?? []) as SpecializationByProgram[];

  return {
    ...query,
    specializations: items,
    concentrations: items,
    hasSpecializations: items.length > 0,
  };
};

export default useGetSpecializationByProgramIdQuery;
